import OPAC from './OPAC';
export default OPAC;